// extracted by mini-css-extract-plugin
export default {"ctn":"subject_ctn__PbCXW","main":"subject_main__BGHr4","sec":"subject_sec__OD+cS"};